import {Component, Input} from '@angular/core';
import {ChatMessage} from '../../../models/chat-message';

@Component({
  selector: 'app-user-input-card',
  standalone: true,
  imports: [],
  templateUrl: './user-input-card.component.html',
  styleUrl: './user-input-card.component.scss'
})
export class UserInputCardComponent {
  @Input()
  data: ChatMessage;
}
